import { render, staticRenderFns } from "./ArquivoInput.vue?vue&type=template&id=e242d8de"
import script from "./ArquivoInput.vue?vue&type=script&lang=js"
export * from "./ArquivoInput.vue?vue&type=script&lang=js"
import style0 from "./ArquivoInput.vue?vue&type=style&index=0&id=e242d8de&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
